module.exports = __webpack_public_path__ + "static/media/HCMM425.22a954f0.jpg";